let isScrolling = false;
  function scrollToSection(button, sectionId) {
    isScrolling = true;
    var offsetTop = null;
    if(sectionId.indexOf("All-Ebikes") == -1){
      const targetElement = document.getElementById(sectionId);
      offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - 100;
    }else{
      offsetTop = 0;
    }
    
    window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
    });

    const buttons = document.querySelectorAll('.custom-navigation-section .navigation-item');
    buttons.forEach(button => button.classList.remove('active'));
    button.classList.add('active');

    setTimeout(() => {
        isScrolling = false;
    }, 1000);
  }

  function ensureButtonInView(button) {
    const container = document.querySelector('.card-carousel__container');
    const buttonRect = button.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    // 获取当前的translate3d值
    // const currentTransform = container.style.transform;
    // const match = currentTransform.match(/translate3d\(([^,]+)px/);
    // const currentX = match ? parseFloat(match[1]) : 0;

    if (buttonRect.left < containerRect.left) {
        // 如果按钮的左边界超出容器的左边界，向右移动
        const newX = (containerRect.left - buttonRect.left) * -1;
        container.style.transform = `translate3d(${newX}px, 0, 0)`;
    } else if (buttonRect.right > containerRect.right) {
        // 如果按钮的右边界超出容器的右边界，向左移动
        const newX = (buttonRect.right - containerRect.right) * -1;
        container.style.transform = `translate3d(${newX}px, 0, 0)`;
    }
  }
  function updateActiveButton() {
    if (isScrolling) return;
    const sections = document.querySelectorAll('.kol-customer-reviews-section');
    const buttons = document.querySelectorAll('.navigation-item');

    let activeSectionId = null;

    sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top >= 0 && rect.top <= window.innerHeight / 2) {
            activeSectionId = section.id;
        }
    });

    if (activeSectionId) {
        buttons.forEach(btn => btn.classList.remove('active'));
        const activeButton = document.querySelector(`.navigation-item[data-section="${activeSectionId}"]`);
        if (activeButton) {
            activeButton.classList.add('active');
            var index = activeButton.getAttribute('data-index');
            ensureButtonInView(activeButton, index);
        }
    }
  }
  // 监听滚动事件
  // window.addEventListener('scroll', updateActiveButton);
  // debounce 函数
function debounce(func, wait) {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

// 使用 debounce 包装 updateActiveButton
const debouncedUpdateActiveButton = debounce(updateActiveButton, 100);

// 监听滚动事件
window.addEventListener('scroll', debouncedUpdateActiveButton);


function showTab(tabElement, tabName) {
    const loadReview = tabElement.getAttribute('data-load')
    if(tabName == 'reviews' && loadReview == "false"){
      window.okeWidgetApi.initAllWidgets()
      tabElement.setAttribute('data-load',"true")
    }
    const tabGroup = tabElement.closest('.product-reviews-section');
    const tabs = tabGroup.querySelectorAll('.tab-item');
    const contents = tabGroup.querySelectorAll('.content');

    tabs.forEach(tab => tab.classList.remove('active'));
    contents.forEach(content => content.classList.remove('active'));

    tabElement.classList.add('active');
    tabGroup.querySelector(`#${tabName}`).classList.add('active');
}

function toggleVideos(button) {
    const contentGroup = button.closest('.product-reviews-section');
    const videos = contentGroup.querySelectorAll('.video-item');
    const isExpanded = button.textContent === 'Show Less';
    const maxVisible = window.innerWidth <= 600 ? 4 : 8;
    const deviceMaxVisible = window.innerWidth <= 600 ? 8 : 16;

    videos.forEach((video, index) => {
        if (index >= maxVisible && index < deviceMaxVisible) {
            video.style.display = isExpanded ? 'none' : 'block';
        }
    });

    button.textContent = isExpanded ? 'Show More' : 'Show Less';
}

document.querySelectorAll('.custom-navigation-buttons .navigation-item').forEach(button => {
    button.addEventListener('click', (event) => {
        const sectionId = event.currentTarget.getAttribute('data-section');
        scrollToSection(event.currentTarget, sectionId);
    });
});

document.querySelectorAll('.kol-customer-reviews-section .tab-item').forEach(button => {
    button.addEventListener('click', (event) => {
        const tab = event.currentTarget.getAttribute('data-tab');
        showTab(event.currentTarget, tab);
    });
});